export enum FileExtensions {
    docx = 'docx',
    jpg = 'jpg',
    jpeg = 'jpeg',
    png = 'png',
    gif = 'gif',
}
